import type { StatusDotColor } from "../Display/StatusDot";
import { StatusDot } from "../Display/StatusDot";
import { T } from "../Typography/T";

interface StatusDotCellProps {
  color: StatusDotColor | undefined;
  label?: string | undefined;
  pulse?: boolean;
}

export function StatusDotCell({ color, label, pulse }: StatusDotCellProps) {
  if (!color) {
    return (
      <T color="faint" size="xs">
        {"\u2014"}
      </T>
    );
  }

  return <StatusDot color={color} label={label} pulse={pulse} />;
}
